import { VStack } from 'src/components/BasicComponents';
import { DocuLink } from '../../BasicComponents/Links';

export function DefaultTimingSystemConfiguration() {
  return (
    <VStack>
      <p>
        Read the
        <DocuLink
          path="predictive-tracking-with-data-from-timekeeping/other-timing-sytem#foward-data"
          style={{ margin: '1ch' }}
        />
        to set up your timing system for forwarding reads to Racemap.
      </p>
    </VStack>
  );
}
